"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLASS_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = _interopRequireDefault(require("../theme"));
var _media = _interopRequireDefault(require("../media"));
var _IconDocumentTemplate = _interopRequireDefault(require("./Icon/IconDocumentTemplate"));
var _IconWebform = _interopRequireDefault(require("./Icon/IconWebform"));
var _IconSignature = _interopRequireDefault(require("./Icon/IconSignature"));
var _helpers = require("../helpers");
const _excluded = ["to", "linkComponent", "color", "borderColor", "textColor", "hoverColor", "children", "className", "isActive", "inactiveColor", "hoverActive", "iconFill", "IconComponent", "ignoreMediaQuery"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CLASS_NAME = exports.CLASS_NAME = 'pill';
const StyledPill = _styledComponents.default.div.withConfig({
  shouldForwardProp: prop => ['bgColor', 'isActive', 'borderColor', 'textColor', 'hoverColor', 'inactiveColor', 'ignoreMediaQuery'].indexOf(prop) === -1
})`
  display: inline-flex;
  align-items: center;
  border-radius: 46px;
  gap: 10px;
  background: ${({
  bgColor,
  isActive
}) => isActive ? bgColor ?? _theme.default.colors.white : _theme.default.colors.blacks[0]};
  border: 2px solid
    ${({
  borderColor,
  isActive,
  inactiveColor
}) => isActive ? borderColor ?? 'transparent' : inactiveColor};
  font-size: 18px;
  line-height: 1;
  text-decoration: none !important;
  color: ${({
  textColor,
  isActive,
  inactiveColor
}) => isActive ? textColor ?? _theme.default.colors.black : inactiveColor} !important;
  ${({
  isActive
}) => isActive && 'font-weight: 500;'}
  padding: 8px 16px;

  :hover {
    ${({
  hoverColor
}) => hoverColor && `background: ${hoverColor};`}
  }

  ${({
  ignoreMediaQuery
}) => !ignoreMediaQuery && (0, _styledComponents.css)`
      ${_media.default.giant`
        font-size: 24px;
        padding: 12px 20px;
      `}
    `}

  svg {
    width: 18px;
    height: 18px;

    ${({
  ignoreMediaQuery
}) => !ignoreMediaQuery && (0, _styledComponents.css)`
        ${_media.default.giant`
          width: 24px;
          height: 24px;
        `}
      `}
  }
`;
const Pill = _ref => {
  let {
      to,
      linkComponent,
      color,
      borderColor,
      textColor,
      hoverColor,
      children,
      className,
      isActive,
      inactiveColor,
      hoverActive = true,
      iconFill,
      IconComponent,
      ignoreMediaQuery = false
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const [isHovered, setIsHovered] = _react.default.useState(false);
  const isActiveOrHoverActive = isActive || hoverActive && isHovered;
  const pillContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, IconComponent && /*#__PURE__*/_react.default.createElement(IconComponent, {
    fill: isActiveOrHoverActive ? iconFill ?? _theme.default.colors.black : inactiveColor
  }), children);
  const pillProps = Object.assign({
    bgColor: color,
    borderColor,
    textColor,
    isActive: isActiveOrHoverActive,
    hoverColor,
    inactiveColor,
    className: (0, _helpers.classString)([CLASS_NAME, className]),
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    ignoreMediaQuery
  }, others);
  if (to) {
    const LinkComponent = linkComponent;
    return /*#__PURE__*/_react.default.createElement(StyledPill, (0, _extends2.default)({
      to: to,
      as: LinkComponent
    }, pillProps), pillContent);
  }
  return /*#__PURE__*/_react.default.createElement(StyledPill, pillProps, pillContent);
};
Pill.Workflows = _ref2 => {
  let {
      children
    } = _ref2,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(Pill, (0, _extends2.default)({
    color: _theme.default.colors.greens[30],
    hoverColor: _theme.default.colors.greens[20],
    IconComponent: _IconWebform.default
  }, props), children);
};
Pill.PDFServices = _ref3 => {
  let {
      children
    } = _ref3,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(Pill, (0, _extends2.default)({
    color: _theme.default.colors.blues[30],
    hoverColor: _theme.default.colors.blues[20],
    IconComponent: _IconDocumentTemplate.default
  }, props), children);
};
Pill.ESign = _ref4 => {
  let {
      children
    } = _ref4,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(Pill, (0, _extends2.default)({
    color: _theme.default.colors.yellows[30],
    hoverColor: _theme.default.colors.yellows[20],
    IconComponent: _IconSignature.default
  }, props), children);
};
var _default = exports.default = Pill;
Pill.defaultProps = {
  isActive: true,
  ignoreMediaQuery: false
};
Pill.propTypes = {
  to: _propTypes.default.string,
  color: _propTypes.default.string,
  borderColor: _propTypes.default.string,
  textColor: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  inactiveColor: _propTypes.default.string,
  hoverColor: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  linkComponent: _propTypes.default.elementType,
  IconComponent: _propTypes.default.elementType,
  hoverActive: _propTypes.default.bool,
  iconFill: _propTypes.default.string,
  ignoreMediaQuery: _propTypes.default.bool
};